var Woo_Orders = {
	init:function(){
		$(".Myaccount-box .buttons").find(".view").on("click touchend", function(e){
			e.stopPropagation();
			e.preventDefault();
			
			if(e.type == "touchend"){
				$(this).off("click");
			}
			
			
			if($(this).closest(".Myaccount-box").hasClass("open")){
				Woo_Orders.close_details($(this).closest(".Myaccount-box"));	
			}else{
				Woo_Orders.open_details($(this).closest(".Myaccount-box"));				
			}
			
			
			
		});
	},
	open_details:function(pTarget){
		pTarget.addClass("open");
		
		pTarget.find(".additional-infos-container").css({height:pTarget.find(".additionals-infos").height()});
	},
	close_details:function(pTarget){
		pTarget.removeClass("open");
		
		pTarget.find(".additional-infos-container").css({height:0});
	}
	
}

$(window).load(function(){
	if($(".my_account_orders").length){
		Woo_Orders.init();
	}
})